<!-- auth-page wrapper -->
<div class="auth-page-wrapper auth-bg-cover py-5 d-flex justify-content-center align-items-center min-vh-100">
  <div class="bg-overlay"></div>
  <!-- auth-page content -->
  <div class="auth-page-content overflow-hidden pt-lg-5">
      <div class="container">
          <div class="row">
              <div class="col-lg-12">
                  <div class="card overflow-hidden m-0">
                      <div class="row justify-content-center g-0">
                          <div class="col-lg-6">
                              <div class="p-lg-5 p-4 auth-one-bg h-100">
                                  <div class="bg-overlay"></div>
                                  <div class="position-relative h-100 d-flex flex-column">
                                      <!-- <div class="mb-4">
                                          <a routerLink="" class="d-block">
                                              <img src="assets/images/logo-light.png" alt="" height="18">
                                          </a>
                                      </div> -->
                                      <div class="mt-auto">
                                          <div class="mb-3">
                                              <i class="ri-double-quotes-l display-4 text-success"></i>
                                          </div>

                                          <ngb-carousel [showNavigationArrows]="showNavigationArrows">
                                            <ng-template ngbSlide>
                                              <div class="carousel-inner text-center text-white-50 pb-5">
                                                <div class="carousel-item active">
                                                  <p class="fs-15 fst-italic">" Great! Manage your appointments with your leads! "</p>
                                                </div>
                                              </div>
                                            </ng-template>
                                            <ng-template ngbSlide>
                                              <div class="carousel-inner text-center text-white-50 pb-5">
                                                <div class="carousel-item active">
                                                  <p class="fs-15 fst-italic">" The portal is really great with an amazing customer support."</p>
                                                </div>
                                              </div>
                                            </ng-template>
                                            <ng-template ngbSlide>
                                              <div class="carousel-inner text-center text-white-50 pb-5">
                                                <div class="carousel-item active">
                                                    <p class="fs-15 fst-italic">" Now you can see all the information of the leads. "</p>
                                                  </div>
                                                </div>
                                            </ng-template>
                                          </ngb-carousel>
                                          <!-- end carousel -->

                                      </div>
                                  </div>
                              </div>
                          </div>

                          <div class="col-lg-6">
                              <div class="p-lg-5 p-4">
                                <div class="logo-login">
                                    <a routerLink="" class="d-block">
                                        <img src="assets/images/logo_new.png" alt="">
                                    </a>
                                </div>
                                  <div>
                                      <h5 class="text-primary">Register Account</h5>
                                      <p class="text-muted">Get your account now.</p>
                                  </div>

                                  <div class="mt-4">
                                      <form [formGroup]="SignupForm" (ngSubmit)="saveUser()">
                                          <div class="row">
                                              <div class="col-md-6 mb-3">
												<label for="firstName" class="form-label">First Name <span class="text-danger">*</span></label>
												<input type="text" class="form-control" id="firstName" placeholder="Enter first name" formControlName="firstName"
													[ngClass]="{ 'is-invalid': f['firstName'].dirty && f['firstName'].errors }"
													(blur)="validateField('firstName')">
												<div class="invalid-feedback">
													<span *ngIf="f['firstName'].errors?.['required']">First name is required</span>
													<span *ngIf="f['firstName'].errors?.['minlength']">Minimum 2 characters required</span>
												</div>
                                              </div>
                                              <div class="col-md-6 mb-3">
                                                  <label for="lastName" class="form-label">Last Name <span class="text-danger">*</span></label>
												  <input type="text" class="form-control" id="lastName" placeholder="Enter last name" formControlName="lastName" [ngClass]="{ 'is-invalid': f['lastName'].dirty && f['lastName'].errors }" (blur)="validateField('lastName')">
                                                  <div class="invalid-feedback">
                                                      <span *ngIf="f['lastName'].errors?.['required']">Last name is required</span>
                                                      <span *ngIf="f['lastName'].errors?.['minlength']">Minimum 2 characters required</span>
                                                  </div>
                                              </div>
                                          </div>

                                          <div class="mb-3">
                                              <label for="companyName" class="form-label">Company Name <span class="text-danger">*</span></label>
                                              <input type="text" class="form-control" id="companyName" placeholder="Enter company name" formControlName="companyName" [ngClass]="{ 'is-invalid': f['companyName'].dirty && f['companyName'].errors }" (blur)="validateField('companyName')">
                                              <div class="invalid-feedback">
                                                  <span *ngIf="f['companyName'].errors?.['required']">Company name is required</span>
                                              </div>
                                          </div>

                                          <div class="mb-3">
                                              <label for="useremail" class="form-label">Email <span class="text-danger">*</span></label>
                                              <input type="email" class="form-control" id="useremail" placeholder="Enter email address" formControlName="email" [ngClass]="{ 'is-invalid': f['email'].dirty && f['email'].errors }" (blur)="validateField('email')">
                                              <div class="invalid-feedback">
                                                  <span *ngIf="f['email'].errors?.['required']">Email is required</span>
                                                  <span *ngIf="f['email'].errors?.['email']">Please enter a valid email address</span>
                                              </div>
                                          </div>

                                          <div class="mb-3">
                                              <label for="mobilePhone" class="form-label">Mobile Phone <span class="text-danger">*</span></label>
                                              <input type="tel" class="form-control" id="mobilePhone" placeholder="Enter mobile number" formControlName="mobilePhone" [ngClass]="{ 'is-invalid': f['mobilePhone'].dirty && f['mobilePhone'].errors }" (blur)="validateField('mobilePhone')">
                                              <div class="invalid-feedback">
                                                  <span *ngIf="f['mobilePhone'].errors?.['required']">Mobile number is required</span>
                                                  <span *ngIf="f['mobilePhone'].errors?.['pattern']">Please enter a valid 10-digit phone number</span>
                                              </div>
                                          </div>

                                          <div class="mb-3">
                                              <label for="address" class="form-label">Address <span class="text-danger">*</span></label>
                                              <input type="text" class="form-control" id="address" placeholder="Enter your address" formControlName="address" [ngClass]="{ 'is-invalid': f['address'].dirty && f['address'].errors }" (blur)="validateField('address')">
                                              <div class="invalid-feedback">
                                                  <span *ngIf="f['address'].errors?.['required']">Address is required</span>
                                              </div>
                                          </div>

                                          <div class="row">
                                              <div class="col-md-6 mb-3">
                                                  <label for="city" class="form-label">City <span class="text-danger">*</span></label>
                                                  <input type="text" class="form-control" id="city" placeholder="Enter city" formControlName="city" [ngClass]="{ 'is-invalid': f['city'].dirty && f['city'].errors }" (blur)="validateField('city')">
                                                  <div class="invalid-feedback">
                                                      <span *ngIf="f['city'].errors?.['required']">City is required</span>
                                                  </div>
                                              </div>
                                              <div class="col-md-3 mb-3">
                                                  <label for="state" class="form-label">State <span class="text-danger">*</span></label>
                                                  <select class="form-select" id="state" formControlName="state" [ngClass]="{ 'is-invalid': f['state'].dirty && f['state'].errors }" (blur)="validateField('state')">
                                                      <option value="" selected disabled>Choose...</option>
                                                      <option *ngFor="let state of states" [value]="state.smallName">{{ state.name }}</option>
                                                  </select>
                                                  <div class="invalid-feedback">
                                                      <span *ngIf="f['state'].errors?.['required']">State is required</span>
                                                  </div>
                                              </div>
                                              <div class="col-md-3 mb-3">
                                                  <label for="zipCode" class="form-label">ZIP Code <span class="text-danger">*</span></label>
                                                  <input type="text" class="form-control" id="zipCode" placeholder="ZIP code" formControlName="zipCode" [ngClass]="{ 'is-invalid': f['zipCode'].dirty && f['zipCode'].errors }" (blur)="validateField('zipCode')">
                                                  <div class="invalid-feedback">
                                                      <span *ngIf="f['zipCode'].errors?.['required']">ZIP code is required</span>
                                                      <span *ngIf="f['zipCode'].errors?.['pattern']">Please enter a valid ZIP code</span>
                                                  </div>
                                              </div>
                                          </div>

                                          <div class="mb-3">
                                              <label for="timezone" class="form-label">Timezone <span class="text-danger">*</span></label>
                                              <select class="form-select" id="timezone" formControlName="timezone" [ngClass]="{ 'is-invalid': f['timezone'].dirty && f['timezone'].errors }" (blur)="validateField('timezone')">
                                                  <option value="" disabled selected>Select timezone</option>
                                                  <option *ngFor="let tz of timezones" [value]="tz.name">{{ tz.name }}</option>
                                              </select>
                                              <div class="invalid-feedback">
                                                  <span *ngIf="f['timezone'].errors?.['required']">Timezone is required</span>
                                              </div>
                                          </div>

                                          <div class="mb-3">
                                            <label for="userpassword" class="form-label">Password <span class="text-danger">*</span></label>
                                            <div class="position-relative auth-pass-inputgroup">
                                              <input [type]="fieldTextType ? 'text' : 'password'" class="form-control pe-5 password-input" placeholder="Enter password" id="password-input" formControlName="password" [ngClass]="{ 'is-invalid': f['lastName'].dirty && f['password'].errors }" (blur)="validateField('password')">
                                              <button class="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted password-addon" type="button" (click)="toggleFieldTextType()">
                                                  <i class="ri-eye-fill align-middle" [ngClass]="{'mdi-eye-off-outline': !fieldTextType, 'mdi-eye-outline': fieldTextType}"></i>
                                              </button>
                                              <div class="invalid-feedback">
                                                  <span *ngIf="f['password'].errors?.['required']">Password is required</span>
                                                  <span *ngIf="f['password'].errors?.['minlength']">Password must be at least 8 characters</span>
                                                  <span *ngIf="f['password'].errors?.['pattern']">Must contain uppercase, lowercase and number</span>
                                              </div>
                                            </div>
                                          </div>
                                          <div id="password-contain" class="p-3 bg-light mb-2 rounded">
                                            <h5 class="fs-13">Password must contain:</h5>
                                            <p id="pass-length" class="invalid fs-12 mb-2">Minimum <b>8 characters</b></p>
                                            <p id="pass-lower" class="invalid fs-12 mb-2">At <b>lowercase</b> letter (a-z)</p>
                                            <p id="pass-upper" class="invalid fs-12 mb-2">At least <b>uppercase</b> letter (A-Z)</p>
                                            <p id="pass-number" class="invalid fs-12 mb-0">A least <b>number</b> (0-9)</p>
                                          </div>

                                          <div class="mb-4">
                                              <p class="mb-0 fs-12 text-muted fst-italic">By registering you agree to the LMS Leads <a href="javascript:void(0);" class="text-primary text-decoration-underline fst-normal fw-medium">Terms of Use</a></p>
                                          </div>

                                          <div class="mt-4">
											  <button
													type="submit"
													class="btn btn-primary w-100"
													[ngClass]="{ 'btn-load': loading }"
													[disabled]="loading || SignupForm.invalid">
													<span class="d-flex align-items-center" *ngIf="loading">
														<span class="flex-grow-1 me-2">
															Loading...
														</span>
														<span class="spinner-border flex-shrink-0" role="status">
															<span class="visually-hidden">Loading...</span>
														</span>
													</span>
													<span *ngIf="!loading">Sign Up</span>
												</button>



                                          </div>

                                          <!-- <div class="mt-4 text-center">
                                              <div class="signin-other-title">
                                                  <h5 class="fs-13 mb-4 title text-muted">Create account with</h5>
                                              </div>

                                              <div class="d-flex gap-2 justify-content-center">
                                                  <button type="button" class="btn btn-primary btn-icon waves-effect waves-light"><i class="ri-facebook-fill fs-16"></i></button>
                                                  <button type="button" class="btn btn-danger btn-icon waves-effect waves-light"><i class="ri-google-fill fs-16"></i></button>
                                                  <button type="button" class="btn btn-dark btn-icon waves-effect waves-light"><i class="ri-github-fill fs-16"></i></button>
                                                  <button type="button" class="btn btn-info btn-icon waves-effect waves-light"><i class="ri-twitter-fill fs-16"></i></button>
                                              </div>
                                          </div> -->
                                      </form>

                                      <div class="mt-5 text-center">
                                          <p class="mb-0">Already have an account? <a routerLink="/auth/signin/cover" class="fw-semibold text-primary text-decoration-underline">Sign in</a></p>
                                      </div>
                                  </div>
                                  <div class="mt-5 text-center" *ngIf="messageError!=''">
                                    <app-danger-msg [msg]="messageError"></app-danger-msg>
                                </div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <!-- end card -->
              </div>
              <!-- end col -->

          </div>
          <!-- end row -->
      </div>
      <!-- end container -->
  </div>
  <!-- end auth page content -->

  <!-- footer -->
  <footer class="footer">
    <div class="container">
        <div class="row">
            <div class="col-lg-12">
                <div class="text-center">
                    <p class="mb-0">&copy; {{year}} LMS leads. <i class="mdi mdi-heart text-danger"></i> </p>
                </div>
            </div>
        </div>
    </div>
</footer>
  <!-- end Footer -->
</div>
<!-- end auth-page-wrapper -->
